import React from 'react';
import { FileText } from 'lucide-react';

interface DocumentMessageBubbleProps {
  documentUrl: string | null;
  caption?: string | null;
  fileName?: string | null;
  timestamp?: string;
}

export const DocumentMessageBubble: React.FC<DocumentMessageBubbleProps> = ({ 
  caption,
  fileName,
  timestamp 
}) => {
  return (
    <div className="flex justify-end mb-2">
      <div className="bg-[#DCF8C6] rounded-lg px-3 py-2 max-w-[85%] shadow-sm">
        <div className="flex items-center gap-3 mb-1">
          <div className="flex-shrink-0 w-10 h-10 rounded bg-white/50 flex items-center justify-center">
            <FileText className="h-5 w-5 text-gray-600" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-gray-800 truncate">
              {fileName || 'documento'}
            </p>
            <p className="text-xs text-gray-600">
              Documento
            </p>
          </div>
        </div>
        
        {caption && (
          <div className="mt-2 pt-2 border-t border-gray-300">
            <p className="text-sm text-gray-800 whitespace-pre-wrap break-words">
              {caption}
            </p>
          </div>
        )}
        
        <div className="flex justify-end items-center gap-1 mt-1">
          <span className="text-[10px] text-gray-600">
            {timestamp || new Date().toLocaleTimeString('es', { hour: '2-digit', minute: '2-digit' })}
          </span>
        </div>
      </div>
    </div>
  );
};
